import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=a2875cf8&scoped=true&"
import script from "./AgentDetail.vue?vue&type=script&lang=js&"
export * from "./AgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=a2875cf8&prod&scoped=true&lang=css&"
import style1 from "./AgentDetail.vue?vue&type=style&index=1&id=a2875cf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2875cf8",
  null
  
)

export default component.exports